import React, { useState, useEffect, useCallback, useMemo, useRef, useImperativeHandle } from 'react';
import { Spin, Tooltip } from 'antd';
import LoadingOutlined from '@ant-design/icons/LoadingOutlined';
import classnames from 'classnames';
import { apiHolder as api, apis, mailPerfTool, } from 'api';
import ReadListIcons from '@web-common/components/UI/Icons/svgs/ReadListSvgs';
import { BackToTopNewIcon } from '@web-common/components/UI/Icons/icons';
import '../../mailBox.scss';
import '../MailList/index.scss';
import MailList from '../MailList/MailList';
import MailListLong from '../MailList/MailListLong';
import MailWrap from './mailListWrap';
import useState2RM from '../../hooks/useState2ReduxMock';
import useMailStore from '../../hooks/useMailStoreRedux';
import { getTopMailSumHeight, getTreeStatesByAccount, folderIdIsContact, importMails, getEmlFileFromDragTrans, dragTransFileHasEml, promiseIsTimeOut, getMainAccount, folderIdIsAllFolder, folderIdIsAllUnreadFolder, openMailInWinow, transTag2Name, } from '../../util';
import { Thunks } from '@web-common/state/reducer/mailReducer';
import { MailActions, useActions, useAppDispatch, useAppSelector } from '@web-common/state/createStore';
import { FLOLDER, TASK_MAIL_STATUS } from '../../common/constant';
import FilterTab from './filterElement';
import { actions as mailTabActions, MailTabThunks, tabType } from '@web-common/state/reducer/mailTabReducer';
import { AutoSizer } from 'react-virtualized/dist/commonjs/AutoSizer';
import useThrottleForEvent from '../../hooks/useThrottleForEvent';
const MailConfApi = api.api.requireLogicalApi(apis.mailConfApiImpl);
const MailApi = api.api.requireLogicalApi(apis.mailApiImpl);
const systemApi = api.api.getSystemApi();
const eventApi = api.api.getEventApi();
const contactApi = api.api.requireLogicalApi(apis.contactApiImpl);
const accountApi = api.api.requireLogicalApi(apis.accountApiImpl);
import useShouldUseRealList from '../../hooks/useShouldUseRealList';
const performance = api.api.requireLogicalApi(apis.performanceImpl);
const performanceApi = api.api.requireLogicalApi(apis.performanceImpl);
import useListDiffFouceRender from './useListDiffFouceRender';
import StarFolderEmptyContent from '@web-mail/components/StarContact/EmptyContact';
import MailListPager from './realListPager';
import variables from '@web-common/styles/export.module.scss';
import useDebounceForEvent from '@web-mail/hooks/useDebounceForEvent';
import useCreateCallbackForEvent from '@web-mail/hooks/useCreateCallbackForEvent';
import { getIn18Text } from 'api';
import useStateRef from '@web-mail/hooks/useStateRef';
import Button from '@lingxi-common-component/sirius-ui/Button';
import { getModuleAccessSelector } from '@web-common/state/reducer/privilegeReducer';
import MailListTips from '@web-mail/components/MailListTips/MailListTips';
import { createAccountEmailKey } from '@web-common/components/util/contact';
import { refreshContactDataByEmails } from '@web-common/state/reducer/contactReducer';
import { safeHTML } from '@web-common/utils/xssUtils';
import DetailCardSender from '@web-mail/components/DetailCardSender/DetailCardSender';
import useEdmSendCount from '@/components/Layout/Customer/components/hooks/useEdmSendCount';
import { useGetProductAuth } from '@web-common/hooks/useGetProductAuth';
import SiriusModal from '@web-common/components/UI/Modal/SiriusModal';
import { Input, Form } from 'antd';
const ListFail = (props) => {
    const { loading = false, onRefresh = () => { } } = props;
    return (React.createElement("div", { className: "m-list" },
        React.createElement("div", { className: "m-list-empty" },
            React.createElement("div", { className: "empty" }, getIn18Text('JIAZAISHIBAI')),
            loading ? (React.createElement(Spin, { indicator: React.createElement(LoadingOutlined, { style: { fontSize: 24 }, spin: true }) })) : (React.createElement("div", { className: "refresh", onClick: onRefresh }, getIn18Text('ZHONGXINJIAZAI'))))));
};
const ListEmpty = (props) => {
    const { name = '', onRefresh = () => { }, showLogo = true, btnRender, otherRender } = props;
    const Btn = useMemo(() => {
        if (typeof btnRender === 'function') {
            return btnRender();
        }
        else {
            return React.createElement(React.Fragment, null, getIn18Text('SHUAXIN'));
        }
    }, [btnRender]);
    const otherRenderDom = useMemo(() => {
        if (typeof otherRender === 'function') {
            return otherRender();
        }
        else {
            return null;
        }
    }, [otherRender]);
    return (React.createElement("div", { className: "m-list" },
        React.createElement("div", { className: "m-list-empty" },
            showLogo && React.createElement("div", { className: "sirius-empty sirius-empty-doc", style: { marginBottom: '20px' } }),
            React.createElement("div", { className: "empty" }, name),
            React.createElement("div", { className: "refresh", onClick: onRefresh }, Btn),
            otherRenderDom ? React.createElement("div", null, otherRenderDom) : null)));
};
const ListBackTop = (props) => {
    const { style, onClick } = props;
    return (React.createElement("div", { style: style, className: classnames(['back-top-wrapper']) },
        React.createElement(Tooltip, { title: getIn18Text('HUIDAODINGBU'), mouseEnterDelay: 1, mouseLeaveDelay: 0.15 },
            React.createElement(BackToTopNewIcon, { onClick: onClick, style: { cursor: 'pointer' } }))));
};
const MailListWrap = React.forwardRef((props, ref) => {
    const { isLeftRight } = props;
    const listRef = useRef();
    useImperativeHandle(ref, () => listRef.current, []);
    const innerProps = useMemo(() => {
        return Object.assign(Object.assign({}, props), { ref: undefined });
    }, [props]);
    return isLeftRight ? React.createElement(MailList, Object.assign({}, innerProps, { ref: listRef })) : React.createElement(MailListLong, Object.assign({}, innerProps, { ref: listRef }));
});
const topCalculated = 300;
const MailColumnEntry = (props, ref) => {
    const [mailDataList] = useMailStore('mailDataList', { key: 'mailList', exclude: ['receiver'] });
    const [searchList] = useMailStore('searchList', { key: 'search', exclude: ['entry.title', 'receiver', 'entry.brief'] });
    const { isLeftRight } = props;
    const [configMailLayout] = useState2RM('configMailLayout', 'doUpdateConfigMailLayout');
    const isUpDown = useMemo(() => configMailLayout === '3', [configMailLayout]);
    const isColumn = useMemo(() => configMailLayout === '2', [configMailLayout]);
    const dispatch = useAppDispatch();
    const [notice, setNotice] = useState(systemApi.isSysNotificationAvailable() !== 'granted');
    const [curMenuMailId, setCurMenuMailId] = useState();
    const [selectedKeys, setSelectedKeys] = useState2RM('selectedKeys', 'doUpdateSelectedKey');
    const [searchResultObj, setSearchResultObj] = useState2RM('searchResultObj', 'doUpdateSearchResultObj');
    const [listLoading, setListLoading] = useState2RM('listLoading', 'doUpdateMailListLoading');
    const [mailSearching, doUpdateMailSearching] = useState2RM('mailSearching', 'doUpdateMailSearching');
    const isSearching = useMemo(() => !!mailSearching, [mailSearching]);
    const isAdvancedSearch = useMemo(() => mailSearching === 'advanced', [mailSearching]);
    const [scrollTop, setScrollTop] = useState2RM('scrollTop', 'doUpdateMailListScrollTop');
    const [isNoticeNum, setIsNoticeNum] = useState2RM('noticeNum', 'doUpdateNoticeNum');
    const [activeIds, setActiveIds] = useState2RM('activeIds');
    const [mailListMenuVisiable, setMailListMenuVisiable] = useState2RM('mailListMenuVisiable', 'doUpdateMailListMenuVisiable');
    const [selected] = useState2RM('mailListStateTab', 'doUpdateMailListStateTab');
    const [refreshLoading, setFreshLoading] = useState2RM('refreshLoading', 'doUpdateRefreshLoading');
    const [authLock, setAuthLock] = useState2RM('mailFolderIsLock', 'doUpdateMailFolderIsLock');
    const [searchSelected] = useState2RM('searchListStateTab', 'doUpdateSearchListStateTab');
    const [selectedMail, setSelectedMail] = useState2RM('selectedMailId', 'doUpdateSelectedMail');
    const [searchMail, setSearchMail] = useState2RM('activeSearchMailId', 'doUpdateActiveSearchMailId');
    const [mailTreeStateMap, setTreeState] = useState2RM('mailTreeStateMap', 'doUpdateMailTreeState');
    const mailTreeStateMapRef = useStateRef(mailTreeStateMap);
    const [tagName] = useState2RM('mailTagFolderActiveKey');
    const [mailTotal, setMailTotal] = useState2RM('mailTotal', 'doUpdateMailTotal');
    const [listLoadIsFail, setListLoadIsFail] = useState2RM('mailListInitIsFailed', 'doUpdateMailListInitIsFailed');
    const [listModel, setListModel] = useState2RM('defaultMailListSelectedModel');
    const { productVersionInfo: { navigateVersion }, } = useGetProductAuth();
    const selectedKeyIsAllFolder = useAppSelector(state => { var _a; return folderIdIsAllFolder((_a = state.mailReducer.selectedKeys) === null || _a === void 0 ? void 0 : _a.id); });
    const [mailSearchMoreAccounts] = useState2RM('mailSearchMoreAccounts');
    const moreAccounts = useMemo(() => (!isSearching && selectedKeyIsAllFolder) || (isSearching && mailSearchMoreAccounts), [isSearching, selectedKeyIsAllFolder, mailSearchMoreAccounts]);
    const [listIsRefresh] = useState2RM('listIsRefresh');
    const suppressAdvancedRefillOnce = useAppSelector(state => state.mailReducer.suppressAdvancedRefillOnce);
    const suppressAdvancedRefillOnceRef = useStateRef(suppressAdvancedRefillOnce);
    const [isDragModel] = useState2RM('isDragModel');
    const [groupCollapseKeys, setGroupCollapseKeys] = useState2RM('groupCollapseKeys');
    const [searchGroupCollapseKeys, setSearchGroupCollapseKeys] = useState2RM('searchGroupCollapseKeys');
    const emlOverLock = useRef(true);
    const [showMailListDropPanel, setShowMailListDropPanel] = useState(false);
    const shouldUseRealList = useShouldUseRealList();
    const [goUnlockVisible, setGoUnlockVisible] = useState(false);
    const [unlockForm] = Form.useForm();
    const [unlockSubmitting, setUnlockSubmitting] = useState(false);
    const currentTabId = useAppSelector(state => state.mailTabReducer.currentTab.id);
    const reducer = useActions(MailActions);
    const mailTagListStore = useMemo(() => {
        const folderState = getTreeStatesByAccount(mailTreeStateMap, (selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.accountId) || '');
        if (folderState && (folderState === null || folderState === void 0 ? void 0 : folderState.mailTagList)) {
            return folderState === null || folderState === void 0 ? void 0 : folderState.mailTagList;
        }
        return [];
    }, [mailTreeStateMap, selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.accountId]);
    const mailIdList = useMemo(() => {
        var _a, _b;
        const list = isSearching ? searchList : mailDataList;
        return (_b = (_a = list) === null || _a === void 0 ? void 0 : _a.map(item => item === null || item === void 0 ? void 0 : item.id)) === null || _b === void 0 ? void 0 : _b.join(',');
    }, [mailDataList, searchList, isSearching]);
    const readTabMailList = useMemo(() => {
        var _a;
        const list = isSearching ? searchList : mailDataList;
        return (_a = list) === null || _a === void 0 ? void 0 : _a.map(item => {
            var _a;
            let title = getIn18Text('WUZHUTI');
            try {
                title = ((_a = item === null || item === void 0 ? void 0 : item.entry) === null || _a === void 0 ? void 0 : _a.title.replace(/<b>/g, '').replace(/<\/b>/g, '')) || getIn18Text('WUZHUTI');
            }
            catch (e) {
                console.error('[Error reg]', e);
            }
            return {
                id: item === null || item === void 0 ? void 0 : item.id,
                title: title,
            };
        });
    }, [mailDataList, searchList, isSearching]);
    const listFouceRender = useListDiffFouceRender(mailDataList, searchList, isSearching, isLeftRight);
    const mailList = useMemo(() => {
        return isSearching ? searchList : mailDataList;
    }, [isSearching, searchList, mailDataList]);
    const havingContent = useMemo(() => {
        return (mailList && mailList.length > 0) || listLoading;
    }, [mailList, listLoading]);
    const showLock = useMemo(() => {
        return authLock && !isSearching;
    }, [authLock, isSearching]);
    const showListBackTop = useMemo(() => {
        return scrollTop > topCalculated && !authLock;
    }, [authLock, scrollTop]);
    const mailListRef = useRef();
    const curFolderName = useMemo(() => {
        var _a, _b, _c, _d;
        if (selectedKeys) {
            const treeMap = (_a = getTreeStatesByAccount(mailTreeStateMap, selectedKeys.accountId)) === null || _a === void 0 ? void 0 : _a.MailFolderTreeMap;
            if (selectedKeys.id && treeMap && ((_b = treeMap[selectedKeys.id]) === null || _b === void 0 ? void 0 : _b.entry.mailBoxName)) {
                return (_d = (_c = treeMap[selectedKeys.id]) === null || _c === void 0 ? void 0 : _c.entry) === null || _d === void 0 ? void 0 : _d.mailBoxName;
            }
        }
        return '';
    }, [selectedKeys, mailTreeStateMap]);
    const trackMailActiveStart = useCallback((id) => {
        try {
            performanceApi.time({
                statKey: `mail_listclick_content_load_time`,
                statSubKey: id + '',
            });
        }
        catch (e) {
            console.error(e);
        }
    }, []);
    const trackMailActiveStartRef = useCreateCallbackForEvent(trackMailActiveStart);
    const hasCustomerAuth = useAppSelector(state => getModuleAccessSelector(state.privilegeReducer, 'CONTACT', 'VIEW'));
    let empryFolderTip = useMemo(() => {
        let res = getIn18Text('WENJIANJIA');
        if (isSearching) {
            return getIn18Text('SOUSUOJIEGUO') + getIn18Text('MAIL_FOLDER_EMPTY_TIP');
        }
        if (tagName === null || tagName === void 0 ? void 0 : tagName.key) {
            res = transTag2Name(tagName === null || tagName === void 0 ? void 0 : tagName.key);
        }
        if (selected === 'UNREAD' || selected === 'REDFLAG' || selected === 'MY_CUSTOMER') {
            if (selected == 'UNREAD') {
                return getIn18Text('ZANWUWEIDYJ');
            }
            if (selected === 'REDFLAG') {
                return getIn18Text('ZANWUHONGQYJ');
            }
            if (selected === 'MY_CUSTOMER') {
                if (!hasCustomerAuth) {
                    return getIn18Text('WUKEHULBDCKQXQLXGLY');
                }
                else {
                    return getIn18Text('WODEKEHYJLBWK');
                }
            }
        }
        if (selectedKeys.id == FLOLDER.STAR) {
            return getIn18Text('noMarkContact');
        }
        if (folderIdIsContact(selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id)) {
            return getIn18Text('WUWANGLAIYJ');
        }
        if (curFolderName) {
            res = curFolderName;
        }
        return res + getIn18Text('MAIL_FOLDER_EMPTY_TIP');
    }, [isSearching, `${tagName === null || tagName === void 0 ? void 0 : tagName.key}${tagName === null || tagName === void 0 ? void 0 : tagName.accountId}`, curFolderName, selectedKeys, selected, hasCustomerAuth]);
    const handleMailDelete = useCallback((id, isThread, params) => {
        dispatch(Thunks.deleteMail({
            id,
            showLoading: params === null || params === void 0 ? void 0 : params.showLoading,
            isScheduleSend: params === null || params === void 0 ? void 0 : params.isScheduleSend,
            detail: params === null || params === void 0 ? void 0 : params.detail,
        }));
    }, []);
    const refreshPage = useCallback((showMessage = true) => {
        return promiseIsTimeOut(dispatch(Thunks.refreshPage({
            refreshPage: showMessage,
        })), 'pc_refreshPage_timeout', {
            from: 'mailColumnEntry',
            showMessage: showMessage,
        });
    }, []);
    const onListModelChange = useCallback(model => {
        setListModel(model);
    }, []);
    const handleMailMove = useCallback((mid, folder) => {
        reducer.showMailMoveModal({
            mailId: mid,
            folderId: folder,
        });
    }, []);
    const searchListLoadLoading = useRef(false);
    useEffect(() => {
        searchListLoadLoading.current = false;
    }, [selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id, selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.accountId, isSearching, isAdvancedSearch, searchSelected, searchResultObj === null || searchResultObj === void 0 ? void 0 : searchResultObj.fid, mailIdList]);
    const loadSearchListData = useCallback(({ startIndex }, noCache = false) => {
        if (startIndex > 0 && suppressAdvancedRefillOnceRef.current) {
            dispatch(MailActions.doUpdateSuppressAdvancedRefillOnce(false));
            return;
        }
        if (!searchListLoadLoading.current) {
            searchListLoadLoading.current = true;
            if (isAdvancedSearch) {
                return dispatch(Thunks.loadAdvanceSearchMailList({
                    startIndex,
                    noCache,
                })).finally(() => {
                    searchListLoadLoading.current = false;
                });
            }
            return dispatch(Thunks.loadSearchMailList({
                startIndex,
                noCache,
            })).finally(() => {
                searchListLoadLoading.current = false;
            });
        }
    }, [isAdvancedSearch]);
    const listLoadLoading = useRef(false);
    useEffect(() => {
        listLoadLoading.current = false;
    }, [selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id, selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.accountId, mailIdList]);
    const loadMailListData = useCallback(({ startIndex }, noCache = false) => {
        if (!listLoadLoading.current) {
            listLoadLoading.current = true;
            return dispatch(Thunks.loadMailList({
                startIndex,
                noCache,
            })).finally(() => {
                listLoadLoading.current = false;
            });
        }
        return Promise.resolve();
    }, []);
    const openNewWindow = useCallback((ids) => {
        if (ids && ids.length) {
            dispatch(Thunks.openMailInNewWindow(ids[0]));
        }
    }, []);
    const handleMailActive = useCallback((id, index, data) => {
        trackMailActiveStartRef(id);
        const item = data;
        if (item && item.entry && item.entry.id) {
            if (isSearching) {
                setSearchMail({
                    id: id,
                    accountId: '',
                });
            }
            else {
                setSelectedMail({
                    id: id,
                    accountId: '',
                });
            }
        }
    }, [isSearching, isLeftRight, isUpDown]);
    const handleMailDoubleClick = useCallback((mail) => {
        const { isThread, _account, isTpMail, owner } = mail;
        mailPerfTool.mailContent('window', 'start', { isThread: !!isThread });
        if (systemApi.isElectron() && mail.entry.folder === FLOLDER.DRAFT) {
            MailApi.doEditMail(mail.id, { draft: true, _account: mail === null || mail === void 0 ? void 0 : mail._account });
        }
        else {
            openMailInWinow(mail);
        }
    }, []);
    const debouceHandleMailDoubleClick = useDebounceForEvent(handleMailDoubleClick, 400, {
        leading: true,
        trailing: false,
    });
    const mailCardSummary = useCallback((props) => {
        var _a, _b, _c;
        const { data } = props;
        const { _account } = data;
        const { title } = data.entry || {};
        let folderTreeMap = {};
        if (_account && mailTreeStateMapRef.current) {
            let TreeMap = getTreeStatesByAccount(mailTreeStateMapRef.current, _account);
            if (TreeMap) {
                folderTreeMap = TreeMap.MailFolderTreeMap;
            }
        }
        return (React.createElement("div", { style: {
                width: '100%',
                display: 'flex',
                overflow: 'hidden',
            } },
            title ? (React.createElement("span", { dangerouslySetInnerHTML: { __html: safeHTML(title) }, style: {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                } })) : (React.createElement("span", { style: {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                } }, (typeof window !== 'undefined' ? window : global).getLocalLabel('WUZHUTI'))),
            React.createElement("span", { style: {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    paddingLeft: '5px',
                    color: `${variables.text3}`,
                    display: 'flex',
                    flexBasis: '100px',
                    flex: '1 0 auto',
                    maxWidth: '50%',
                } },
                "[",
                React.createElement("span", { style: {
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        color: `${variables.text3}`,
                        display: 'block;',
                    } }, folderTreeMap ? (_c = (_b = folderTreeMap[(_a = data === null || data === void 0 ? void 0 : data.entry) === null || _a === void 0 ? void 0 : _a.folder]) === null || _b === void 0 ? void 0 : _b.entry) === null || _c === void 0 ? void 0 : _c.mailBoxName : ''),
                "]")));
    }, []);
    const mailLongCardDesc = useCallback((props) => {
        var _a, _b, _c;
        const { data } = props;
        let brief = '';
        const { _account } = data;
        const entryBrief = data.entry.brief || '';
        try {
            const emptyBriefReg = /^\s*$/;
            if (!entryBrief || emptyBriefReg.test(entryBrief)) {
                brief = ' ';
            }
            else {
                brief = entryBrief;
            }
        }
        catch (e) {
            console.error('[Error ]mailLongCardDesc error', e);
        }
        let folderTreeMap = {};
        if (_account && mailTreeStateMapRef.current) {
            let TreeMap = getTreeStatesByAccount(mailTreeStateMapRef.current, _account);
            if (TreeMap) {
                folderTreeMap = TreeMap.MailFolderTreeMap;
            }
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("span", { dangerouslySetInnerHTML: { __html: safeHTML(brief) }, style: {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                } }),
            React.createElement("span", { style: { margin: '0px 10px', color: `${variables.text3}`, flexShrink: 0 } },
                "[",
                folderTreeMap ? (_c = (_b = folderTreeMap[(_a = data === null || data === void 0 ? void 0 : data.entry) === null || _a === void 0 ? void 0 : _a.folder]) === null || _b === void 0 ? void 0 : _b.entry) === null || _c === void 0 ? void 0 : _c.mailBoxName : '',
                "]")));
    }, []);
    const handleGroupCollapse = useCallback((id, isCollapse) => {
        setGroupCollapseKeys(list => {
            if (isCollapse) {
                return [...new Set([...list, id])];
            }
            else {
                return list.filter(item => item !== id);
            }
        });
    }, []);
    const listCommonAttr = useMemo(() => {
        const summary = ((selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id) == FLOLDER.UNREAD || (selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id) == FLOLDER.DEFER || folderIdIsAllUnreadFolder(selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id) || isSearching) && !isUpDown
            ? mailCardSummary
            : null;
        const desc = ((selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id) == FLOLDER.UNREAD || folderIdIsAllUnreadFolder(selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id) || isSearching) && isUpDown ? mailLongCardDesc : null;
        return {
            isLeftRight,
            isUpDown,
            activeId: activeIds,
            refreshPage,
            isSearching,
            onDoubleClick: debouceHandleMailDoubleClick,
            onActiveInWindow: openNewWindow,
            listLoading,
            hkDisabled: currentTabId !== '-1' && currentTabId !== '-1/-1',
            mailCardSummary: summary,
            mailCardDesc: desc,
            beforeSelected: (ids, activeIds, curId) => {
                const isTask = {};
                if (!isSearching) {
                    mailDataList.forEach((item) => {
                        var _a;
                        isTask[item.id + ''] = ((_a = item === null || item === void 0 ? void 0 : item.taskInfo) === null || _a === void 0 ? void 0 : _a.status) === TASK_MAIL_STATUS.PROCESSING;
                    });
                }
                else {
                    searchList.forEach((item) => {
                        var _a;
                        isTask[item.id + ''] = ((_a = item === null || item === void 0 ? void 0 : item.taskInfo) === null || _a === void 0 ? void 0 : _a.status) === TASK_MAIL_STATUS.PROCESSING;
                    });
                }
                if (activeIds.length == 1) {
                    return activeIds;
                }
                return activeIds.filter(item => !isTask[item]);
            },
            onSelect: (ids, activeIds, curId) => {
                setActiveIds(activeIds);
            },
            onUnSelect: (ids, activeIds, curId) => {
                setActiveIds(activeIds);
            },
            onActive: handleMailActive,
            onContextMenu: (key, data, index, event) => {
                setMailListMenuVisiable(true);
                if (Array.isArray(data)) {
                    setCurMenuMailId(data === null || data === void 0 ? void 0 : data.map(item => item === null || item === void 0 ? void 0 : item.id));
                }
                else {
                    setCurMenuMailId([data === null || data === void 0 ? void 0 : data.id]);
                }
            },
            from: process.env.BUILD_ISEDM || navigateVersion ? DetailCardSender : null,
        };
    }, [activeIds, isSearching, selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id, listLoading, handleMailActive, isLeftRight, isUpDown, currentTabId, navigateVersion]);
    const longListCommonAttr = useMemo(() => {
        const desc = (selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id) == FLOLDER.UNREAD || folderIdIsAllUnreadFolder(selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id) || isSearching ? mailLongCardDesc : null;
        return {
            isLeftRight,
            isUpDown,
            activeId: activeIds,
            refreshPage,
            isSearching,
            onDoubleClick: debouceHandleMailDoubleClick,
            onActiveInWindow: openNewWindow,
            listLoading,
            hkDisabled: currentTabId !== '-1' && currentTabId !== '-1/-1',
            mailCardDesc: desc,
            beforeSelected: (ids, activeIds, curId) => {
                const isTask = {};
                if (!isSearching) {
                    mailDataList.forEach((item) => {
                        var _a;
                        isTask[item.id + ''] = ((_a = item === null || item === void 0 ? void 0 : item.taskInfo) === null || _a === void 0 ? void 0 : _a.status) === TASK_MAIL_STATUS.PROCESSING;
                    });
                }
                else {
                    searchList.forEach((item) => {
                        var _a;
                        isTask[item.id + ''] = ((_a = item === null || item === void 0 ? void 0 : item.taskInfo) === null || _a === void 0 ? void 0 : _a.status) === TASK_MAIL_STATUS.PROCESSING;
                    });
                }
                if (activeIds.length == 1) {
                    return activeIds;
                }
                return activeIds.filter(item => !isTask[item]);
            },
            onSelect: (ids, activeIds, curId) => {
                setActiveIds(activeIds);
            },
            onUnSelect: (ids, activeIds, curId) => {
                setActiveIds(activeIds);
            },
            onActive: (id, index, data) => {
                var _a;
                trackMailActiveStartRef(id);
                setActiveIds([id]);
                const tabId = `${id}_${Date.now()}`;
                let title = getIn18Text('WUZHUTI');
                try {
                    title = ((_a = data === null || data === void 0 ? void 0 : data.entry) === null || _a === void 0 ? void 0 : _a.title.replace(/<b>/g, '').replace(/<\/b>/g, '')) || getIn18Text('WUZHUTI');
                }
                catch (e) {
                    console.error('[Error reg]', e);
                }
                const mailTabModel = {
                    id: isColumn ? tabId : id,
                    title,
                    type: tabType.read,
                    closeable: true,
                    isActive: true,
                    extra: {
                        accountId: '',
                        originMid: id,
                    },
                };
                if (isColumn) {
                    dispatch(MailTabThunks.getReadMailTabIdByMid({ mid: id })).then(res => {
                        if (res.payload) {
                            dispatch(mailTabActions.doChangeCurrentTab(res.payload));
                        }
                        else {
                            dispatch(Thunks.getMailListRequestParams({ id: id }))
                                .then(res => {
                                var _a, _b, _c;
                                const readTab = {
                                    id: tabId,
                                    currentMid: id,
                                    query: res.payload,
                                    isThread: (_a = res === null || res === void 0 ? void 0 : res.payload) === null || _a === void 0 ? void 0 : _a.isThread,
                                    midList: ((_b = res === null || res === void 0 ? void 0 : res.payload) === null || _b === void 0 ? void 0 : _b.midList) || [],
                                    isSearching,
                                    total: isSearching ? searchResultObj.total : mailTotal,
                                };
                                dispatch(mailTabActions.doSetReadTab(readTab));
                                dispatch(mailTabActions.doSetReadTabMidList({ id: tabId, midList: ((_c = res === null || res === void 0 ? void 0 : res.payload) === null || _c === void 0 ? void 0 : _c.midList) || [] }));
                                dispatch(mailTabActions.doSetReadTabMailList([...readTabMailList]));
                            })
                                .finally(() => {
                                dispatch(mailTabActions.doSetTab(mailTabModel));
                            });
                        }
                    });
                }
                else {
                    dispatch(mailTabActions.doSetTab(mailTabModel));
                }
            },
            onContextMenu: (key, data, index, event) => {
                setMailListMenuVisiable(true);
                if (Array.isArray(data)) {
                    setCurMenuMailId(data === null || data === void 0 ? void 0 : data.map(item => item === null || item === void 0 ? void 0 : item.id));
                }
                else {
                    setCurMenuMailId([data === null || data === void 0 ? void 0 : data.id]);
                }
            },
            from: process.env.BUILD_ISEDM || navigateVersion ? DetailCardSender : null,
        };
    }, [activeIds, isSearching, listLoading, isLeftRight, isUpDown, currentTabId, navigateVersion]);
    const handleSearchInsufficientHeight = useDebounceForEvent(() => {
        if ((searchResultObj === null || searchResultObj === void 0 ? void 0 : searchResultObj.total) && searchList.length < (searchResultObj === null || searchResultObj === void 0 ? void 0 : searchResultObj.total) && !shouldUseRealList) {
            loadSearchListData({
                startIndex: searchList.length,
            });
        }
    }, 800);
    const realListRef = useRef(null);
    const getRealListScrollEl = () => {
        if (realListRef && realListRef.current) {
            return realListRef.current;
        }
        return null;
    };
    const handleRealListScroll = (scrollTop) => {
        if (!shouldUseRealList)
            return;
        const el = getRealListScrollEl();
        if (el) {
            el.scrollTop = scrollTop || 0;
        }
    };
    const handleSearchGroupCollapse = useCallback((id, isCollapse) => {
        setSearchGroupCollapseKeys(list => {
            if (isCollapse) {
                return [...new Set([...list, id])];
            }
            else {
                return list.filter(item => item !== id);
            }
        });
    }, []);
    const searchMailListElement = useCallback((config) => {
        const { height = 0, width = 0 } = config || {};
        const commonAttr = isLeftRight || isUpDown ? listCommonAttr : longListCommonAttr;
        return (React.createElement(MailListWrap, Object.assign({ ref: mailListRef }, commonAttr, { useRealList: shouldUseRealList, realListClassName: "mail-real-list", onRealListScroll: (scrollTop) => {
                handleRealListScroll(scrollTop);
            }, realListPager: !isUpDown &&
                !isLeftRight && (React.createElement("div", { className: "mail-long-list-page-wrapper" },
                ' ',
                React.createElement(MailListPager, { hideOnSinglePage: true, hideQuickJumper: true, showCustomPageSelect: true }))), forceShowAttachment: true, onScroll: throttleOnScroll, scrollTop: scrollTop, listHeight: height, listWidth: width, data: searchList, rowCount: searchResultObj.total, loadMoreRows: loadSearchListData, selectedKeys: searchSelected, isMerging: false, listFouceRender: listFouceRender, selected: selected, listModel: listModel, onDelete: handleMailListDelete, onListModelChange: onListModelChange, useLeftRightHotKey: isUpDown, onContentInsufficientHeight: handleSearchInsufficientHeight, MailMergeConfig: { key: 'search', exclude: ['entry.title', 'receiver', 'entry.brief'] }, onGroupCollapse: handleSearchGroupCollapse, groupCollapse: searchGroupCollapseKeys })));
    }, [
        listCommonAttr,
        scrollTop,
        searchList,
        searchResultObj,
        loadSearchListData,
        searchSelected,
        isLeftRight,
        isUpDown,
        longListCommonAttr,
        listFouceRender,
        listModel,
        selected,
        shouldUseRealList,
        handleRealListScroll,
        searchGroupCollapseKeys,
    ]);
    const emailIdMap = useAppSelector(state => state.contactReducer.emailIdMap);
    const contactMap = useAppSelector(state => state.contactReducer.contactMap);
    const customerMap = useAppSelector(state => state.contactReducer.customerMap);
    useEffect(() => {
        var _a;
        if (process.env.BUILD_ISEDM || navigateVersion) {
            const requestEmails = [];
            mailDataList.forEach(m => {
                var _a, _b, _c;
                const { receiver, _account = getMainAccount() } = m || {};
                const accountAlias = ((_b = (_a = systemApi.getCurrentUser(m === null || m === void 0 ? void 0 : m._account)) === null || _a === void 0 ? void 0 : _a.prop) === null || _b === void 0 ? void 0 : _b.accountAlias) || [];
                const accountAliasArray = Array.isArray(accountAlias) ? accountAlias : [accountAlias];
                const senderEmail = contactApi.doGetModelDisplayEmail((_c = m === null || m === void 0 ? void 0 : m.sender) === null || _c === void 0 ? void 0 : _c.contact);
                const isSend = m
                    ? accountAliasArray.some(account => accountApi.getIsSameSubAccountSync(account, senderEmail)) || accountApi.getIsSameSubAccountSync(senderEmail, m._account)
                    : false;
                if (isSend) {
                    const emails = receiver === null || receiver === void 0 ? void 0 : receiver.map(item => contactApi.doGetModelDisplayEmail(item.contact)).filter(Boolean);
                    if (emails && emails.length) {
                        emails.forEach(email => {
                            const accountEmailKey = createAccountEmailKey(email, _account);
                            const contactId = emailIdMap[accountEmailKey];
                            if (contactId) {
                                const contactModel = contactMap[contactId];
                                const customerModel = customerMap[contactId];
                                if (!contactModel && !customerModel) {
                                    requestEmails.push(email);
                                }
                            }
                            else {
                                requestEmails.push(email);
                            }
                        });
                    }
                }
            });
            if (!!requestEmails.length) {
                const account = ((_a = mailDataList[0]) === null || _a === void 0 ? void 0 : _a._account) || getMainAccount();
                refreshContactDataByEmails({ [account]: [...new Set(requestEmails)] }, new Map());
            }
        }
    }, [mailIdList]);
    const mailIdKey = useMemo(() => {
        try {
            if (mailDataList && mailDataList.length) {
                return mailDataList === null || mailDataList === void 0 ? void 0 : mailDataList.map(item => item === null || item === void 0 ? void 0 : item.id).join(',');
            }
        }
        catch (e) {
            console.error(e);
        }
        return '';
    }, [mailDataList]);
    useEffect(() => {
        try {
            if (mailIdKey) {
                performance.timeEnd({
                    statKey: 'mail_folder_switch',
                    statSubKey: '',
                    params: {
                        folderId: selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id,
                        accountId: (selectedMail === null || selectedMail === void 0 ? void 0 : selectedMail.accountId) + '',
                    },
                });
            }
        }
        catch (e) {
            console.error(e);
        }
    }, [mailIdKey]);
    const throttleOnScroll = useThrottleForEvent((param) => {
        setScrollTop(param.scrollTop);
        if (param.scrollTop <= getTopMailSumHeight(mailDataList) && isNoticeNum != 0) {
            setIsNoticeNum(0);
        }
    }, 400, {
        leading: true,
        trailing: true,
    });
    const handleMailListDragStart = useCallback((e, mail) => {
        reducer.doMailDragStart({
            mailId: mail.entry.id,
            accountId: (mail === null || mail === void 0 ? void 0 : mail._account) || '',
            folderId: mail.entry.folder,
        });
    }, []);
    const handleMailListDragEnd = useCallback((e, mail) => {
        reducer.doMailDragEnd(null);
    }, []);
    const handleMailListDelete = useCallback((idList) => {
        if (idList && idList.length) {
            dispatch(Thunks.deleteMailFromHotKey(idList.length === 1 ? idList[0] : idList));
        }
    }, []);
    const handleListInsufficientHeight = useDebounceForEvent(() => {
        if (mailDataList.length < mailTotal && !shouldUseRealList) {
            loadMailListData({
                startIndex: mailDataList.length,
            });
        }
    }, 800, {
        leading: false,
        trailing: true,
    });
    const defaultListnoMore = useCallback(() => (React.createElement("div", { className: "mail-list-topline" },
        React.createElement("span", null, getIn18Text('JINZHANSHIZUIJINFHFJDYJ', { count: 3000 })))), []);
    const mailListElement = useCallback((config) => {
        const { height = 0, width = 0 } = config || {};
        const commonAttr = isLeftRight || isUpDown ? listCommonAttr : longListCommonAttr;
        return (React.createElement(MailListWrap, Object.assign({ ref: mailListRef }, commonAttr, { useRealList: shouldUseRealList, realListClassName: "mail-real-list", realListPager: !isUpDown &&
                !isLeftRight && (React.createElement("div", { className: "mail-long-list-page-wrapper" },
                ' ',
                React.createElement(MailListPager, { hideOnSinglePage: true, hideQuickJumper: true, showCustomPageSelect: true }))), scrollTop: scrollTop, listHeight: height, listWidth: width, data: mailDataList, rowCount: mailTotal, loadMoreRows: loadMailListData, notice: notice, selectedKeys: selectedKeys, selected: selected, tagName: tagName === null || tagName === void 0 ? void 0 : tagName.key, onScroll: throttleOnScroll, listFouceRender: listFouceRender, onDragStart: handleMailListDragStart, onDragEnd: handleMailListDragEnd, onDelete: handleMailListDelete, listModel: listModel, onListModelChange: onListModelChange, useLeftRightHotKey: isUpDown, isRefresh: listIsRefresh, onContentInsufficientHeight: handleListInsufficientHeight, noMoreRender: selected == 'ATTACHMENT' ? defaultListnoMore : undefined, onGroupCollapse: handleGroupCollapse, groupCollapse: groupCollapseKeys })));
    }, [
        scrollTop,
        listCommonAttr,
        mailIdList,
        mailTotal,
        loadMailListData,
        notice,
        selectedKeys,
        `${tagName === null || tagName === void 0 ? void 0 : tagName.key}${tagName === null || tagName === void 0 ? void 0 : tagName.accountId}`,
        isLeftRight,
        isUpDown,
        longListCommonAttr,
        mailTagListStore,
        selected,
        listFouceRender,
        listModel,
        listIsRefresh,
        shouldUseRealList,
        groupCollapseKeys,
    ]);
    useEffect(() => {
        const showNotice = systemApi.isSysNotificationAvailable() == 'default';
        setNotice(showNotice);
    }, []);
    const ListFailCom = useMemo(() => (React.createElement(ListFail, { loading: refreshLoading, onRefresh: () => {
            setListLoadIsFail(false);
            setListLoading(true);
            refreshPage(false);
        } })), [refreshLoading]);
    const ThirdPartyEmptyContent = useMemo(() => {
        return (React.createElement(ListEmpty, { name: empryFolderTip, showLogo: !isLeftRight && !isUpDown, onRefresh: () => {
                refreshPage(false);
            }, btnRender: () => {
                return (React.createElement(Button, { btnType: "primary", style: { marginTop: '8px' } }, getIn18Text('SHUAXIN')));
            } }));
    }, [selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id, isLeftRight, isUpDown]);
    const [emailList, setEmailList] = useState([]);
    useEdmSendCount(emailList, 'normal', undefined, undefined, undefined, 'customer', undefined, undefined, true);
    const customerReplyEmptyFn = () => {
        setEmailList([{ contactEmail: '', contactName: '' }]);
    };
    const ListEmptCom = useMemo(() => {
        if (!isLeftRight && !isUpDown && (selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id) == FLOLDER.STAR && !isSearching) {
            return React.createElement(StarFolderEmptyContent, null);
        }
        if (selectedKeys.authAccountType != null && (selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.authAccountType) != '0' && !isSearching) {
            return ThirdPartyEmptyContent;
        }
        const otherRender = (selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id) === FLOLDER.EDM_REPLY || (selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id) === FLOLDER.EDM_OTHER_REPLY
            ? () => {
                return (React.createElement("div", { className: "customerReply", style: { display: !isLeftRight ? 'flex' : 'block' } },
                    React.createElement("div", null,
                        getIn18Text('KEQIANWANG'),
                        React.createElement("span", { className: "link", onClick: customerReplyEmptyFn }, getIn18Text('CHUANGJIANGENGDKFRW'))),
                    !isLeftRight && React.createElement("span", null, "\uFF0C"),
                    React.createElement("div", null, getIn18Text('YIJIASUHDQZKHHF'))));
            }
            : null;
        return (React.createElement(ListEmpty, { name: empryFolderTip, selected: selected, showLogo: !isLeftRight && !isUpDown, onRefresh: () => {
                setFreshLoading(true);
                refreshPage(false);
            }, otherRender: otherRender }));
    }, [empryFolderTip, isLeftRight, selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id, selected, isUpDown, isSearching]);
    const ListTipCom = useMemo(() => (listLoadIsFail ? ListFailCom : ListEmptCom), [listLoadIsFail, ListFailCom, ListEmptCom]);
    const MailListCom = useCallback((config) => (React.createElement("div", { className: "m-list", style: process.env.BUILD_ISELECTRON && shouldUseRealList ? { '-webkit-app-region': 'unset' } : {} },
        React.createElement(MailWrap, { visible: mailListMenuVisiable, setVisible: setMailListMenuVisiable, selectedKeys: selectedKeys, selected: selected, isAdvancedSearch: isAdvancedSearch, isSearching: isSearching, onMove: handleMailMove, onDelete: handleMailDelete, activeMailId: curMenuMailId, openNewWindow: openNewWindow, moreAccounts: moreAccounts }, isSearching ? searchMailListElement(config) : mailListElement(config)))), [isSearching, searchMailListElement, mailListElement, mailListMenuVisiable, selectedKeys, selected, isAdvancedSearch, curMenuMailId, shouldUseRealList]);
    const autoSizeElement = useMemo(() => {
        return (React.createElement("div", { style: { width: '100%', flex: '1', minHeight: 0 } },
            React.createElement(AutoSizer, { style: { width: '100%', height: '100%' } }, ({ height, width }) => {
                let max = 1000;
                try {
                    max = (window === null || window === void 0 ? void 0 : window.innerHeight) || 1000;
                }
                catch (e) {
                    console.log('[ window.innerHeight Error]', e);
                }
                const resHeight = height > max ? max : height;
                const listElement = havingContent ? MailListCom({ width, height: resHeight }) : ListTipCom;
                return listElement;
            })));
    }, [havingContent, MailListCom, ListTipCom, shouldUseRealList]);
    const handleEmlDrop = useCallback(event => {
        event.preventDefault();
        const uploadFileList = getEmlFileFromDragTrans(event);
        if (uploadFileList.length) {
            importMails({ fid: Number(selectedKeys.id), fileList: uploadFileList, _account: selectedKeys.accountId }, true).then(() => {
                setTimeout(() => {
                    dispatch(Thunks.refreshMailList({
                        noCache: true,
                        showLoading: false,
                    }));
                }, 1500);
            });
        }
        reducer.updateOuterFileDragLeave({});
    }, [importMails, selectedKeys]);
    const mailListDropPanel = useMemo(() => {
        return isDragModel == 'eml' && showMailListDropPanel && !selectedKeyIsAllFolder ? (React.createElement("div", { className: "mailList-eml-dp-wrap", onDrop: handleEmlDrop },
            React.createElement("div", { className: "eml-dp-border" },
                React.createElement("span", null,
                    getIn18Text('SONGKAIDAORUDAO'),
                    curFolderName)))) : (React.createElement(React.Fragment, null));
    }, [isDragModel, curFolderName, selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.accountId, showMailListDropPanel, selectedKeyIsAllFolder]);
    const debounceCloseEmlDragModel = useDebounceForEvent(() => {
        emlOverLock.current = true;
        setShowMailListDropPanel(false);
    }, 200, {
        leading: false,
    });
    const handleOuterDragOver = useCallback((event) => {
        if (isDragModel !== 'eml' && emlOverLock.current) {
            let couldDrop = dragTransFileHasEml(event);
            if (couldDrop) {
                emlOverLock.current = false;
                setShowMailListDropPanel(true);
            }
        }
        debounceCloseEmlDragModel();
    }, []);
    const throttleHandleOuterDragOver = useThrottleForEvent(handleOuterDragOver, 100);
    const FilterTabElement = useMemo(() => {
        return React.createElement(FilterTab, null);
    }, []);
    const goUnlock = useCallback(() => {
        setGoUnlockVisible(true);
    }, [setGoUnlockVisible]);
    const handleUnlock = useCallback(async () => {
        var _a;
        try {
            const { password } = await unlockForm.validateFields();
            setUnlockSubmitting(true);
            const account = (selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.accountId) || ((_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || '';
            const res = await MailApi.unlockSecurityLock(password, account);
            if (res.code === 'S_OK') {
                setGoUnlockVisible(false);
                unlockForm.resetFields();
                await MailApi.doListMailBox(true, undefined, undefined, account);
                eventApi.sendSysEvent({ eventName: 'mailChanged', eventStrData: 'forceRefreshList' });
            }
            else {
                unlockForm.setFields([{ name: 'password', errors: [getIn18Text('QINGSHURUZHENGQUEMIMA')] }]);
            }
        }
        catch (e) {
            unlockForm.setFields([{ name: 'password', errors: [getIn18Text('QINGSHURUZHENGQUEMIMA')] }]);
        }
        finally {
            setUnlockSubmitting(false);
        }
    }, [unlockForm, selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.accountId, eventApi]);
    const safetyLockEl = (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "m-auth" },
            React.createElement("div", { className: "m-auth-lock" },
                React.createElement(ReadListIcons.LockSvg, null)),
            React.createElement("div", { className: "m-auth-text" }, getIn18Text('GAIWENJIANJIAYI')),
            React.createElement("div", { className: "m-auth-note" },
                React.createElement("span", { className: "link", onClick: () => goUnlock() }, getIn18Text('JILUJIESUO'))))));
    return (React.createElement(React.Fragment, null,
        showLock ? (safetyLockEl) : (React.createElement("div", { className: "m-list-container ant-allow-dark", style: { height: '100%', overflow: 'hidden', display: 'flex', flexDirection: 'column' }, onDragOverCapture: event => {
                event.persist();
                throttleHandleOuterDragOver(event);
            } },
            FilterTabElement,
            React.createElement(MailListTips, null),
            autoSizeElement,
            shouldUseRealList && isLeftRight && (React.createElement("div", { className: "mail-left-right-list-page-wrapper" },
                React.createElement(MailListPager, { showLessItems: true, showCustomPageSizeSelect: true, hidePaginationItem: true, showCustomPageSelect: true, style: { padding: '4px 12px' } }))),
            mailListDropPanel)),
        showListBackTop && (React.createElement(ListBackTop, { style: { bottom: shouldUseRealList ? '100px' : '' }, onClick: () => {
                setScrollTop(0);
            } })),
        React.createElement(SiriusModal, { title: getIn18Text('ANQUANSUOYUMAMA'), visible: goUnlockVisible, onCancel: () => {
                setGoUnlockVisible(false);
                unlockForm.resetFields();
            }, onOk: handleUnlock, okText: getIn18Text('QUEDING'), cancelText: getIn18Text('QUXIAO'), okButtonProps: { loading: unlockSubmitting, disabled: unlockSubmitting }, maskClosable: false, width: 480 },
            React.createElement(Form, { form: unlockForm, layout: "vertical" },
                React.createElement(Form.Item, { name: "password", rules: [{ required: true, message: getIn18Text('MIMABUWEIKONG') }] },
                    React.createElement(Input.Password, { placeholder: getIn18Text('QINGSHURUZHENGQUEMIMA') })),
                React.createElement("div", { className: "m-auth-modal-label" }, getIn18Text('RUOGUOMIMAWEIYIJIEMIMA'))))));
};
export default MailColumnEntry;
